import React from "react";
import FormattedNumber from "@/shared/components/FormattedNumber";
import { SidebarOverlay, SidebarGlass } from "./styledComponents";
import { getNetworkName } from "@/utils/helpers";

function WithdrawSidebar({
  sidebarWithdraw,
  wallet,
  withdrawFrom,
  withdrawTo,
  withdrawAddress,
  withdrawAmount,
  withdrawCoin,
  withdrawError,
  withdrawFee,
  withdrawOtp,
  withdrawTfa,
  selectedWithdrawNetwork,
  internalAmount,
  approxAmountAfterFee,
  isLoadingFee,
  isOtpEnabled,
  isTfaEnabled,
  otpSent,
  isSendingOtp,
  isSubmitting,
  searchLoad,
  approverData,
  onClose,
  onFromChange,
  onToChange,
  onAddressChange,
  onAmountChange,
  onOtpChange,
  onTfaChange,
  onRecipientSelect,
  onRecipientSearch,
  onMaxAmount,
  onSendOtp,
  onResendOtp,
  onSubmit,
  otpMinutes,
  otpSeconds,
  resendOtp,
  otpCount,
  REACT_APP_SOLANA,
  REACT_APP_SMART_CHAIN,
  REACT_APP_POLYGON_MATIC,
  REACT_APP_ETHER,
  REACT_APP_TRON,
  REACT_APP_BTC,
}) {
  if (!sidebarWithdraw) return null;

  const getDisplayAddress = (option) => {
    if (withdrawTo === "onChain_wallet") {
      if (selectedWithdrawNetwork === REACT_APP_SOLANA) {
        return option.onChainSolAddress || "";
      }
      return option.onChainAddress || "";
    } else if (withdrawTo === "internal_custodiy") {
      if (selectedWithdrawNetwork === REACT_APP_SMART_CHAIN || selectedWithdrawNetwork === REACT_APP_POLYGON_MATIC || selectedWithdrawNetwork === REACT_APP_ETHER) {
        return option.address || "";
      } else if (selectedWithdrawNetwork === REACT_APP_SOLANA) {
        return option.sol_address || "";
      } else if (selectedWithdrawNetwork === REACT_APP_TRON) {
        return option.trcWalletAddress || "";
      } else if (selectedWithdrawNetwork === REACT_APP_BTC) {
        return option.btc_address || "";
      }
      return option.address || "";
    }
    return option.address || "";
  };

  const handleRecipientSelect = (option) => {
    onRecipientSelect(option);
    const displayAddress = getDisplayAddress(option);
    if (withdrawTo === "onChain_wallet") {
      if (selectedWithdrawNetwork === REACT_APP_SOLANA) {
        onAddressChange(option.onChainSolAddress || "");
      } else {
        onAddressChange(option.onChainAddress || "");
      }
    } else if (withdrawTo === "internal_custodiy") {
      if (selectedWithdrawNetwork === REACT_APP_SMART_CHAIN || selectedWithdrawNetwork === REACT_APP_POLYGON_MATIC || selectedWithdrawNetwork === REACT_APP_ETHER) {
        onAddressChange(option.address || "");
      } else if (selectedWithdrawNetwork === REACT_APP_SOLANA) {
        onAddressChange(option.sol_address || "");
      } else if (selectedWithdrawNetwork === REACT_APP_TRON) {
        onAddressChange(option.trcWalletAddress || "");
      } else if (selectedWithdrawNetwork === REACT_APP_BTC) {
        onAddressChange(option.btc_address || "");
      } else {
        onAddressChange(option.address || "");
      }
    } else {
      onAddressChange(option.address || "");
    }
  };

  return (
    <>
      <SidebarOverlay onClick={onClose} />
      <SidebarGlass>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0 }}>Withdraw {sidebarWithdraw.symbol}</h3>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "1px solid #5ce9ff",
              color: "#5ce9ff",
              borderRadius: "8px",
              padding: "4px 8px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>

        <div style={{ marginTop: "16px" }}>From</div>
        <select
          value={withdrawFrom}
          onChange={(e) => onFromChange(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "8px",
            marginTop: "4px",
            background: "#0b1220",
            color: "#e5e7eb",
            border: "1px solid #1f2937",
          }}
          disabled={wallet === "On-chain"}
        >
          {wallet === "On-chain" ? (
            <option value="onchain">On-chain Wallet</option>
          ) : (
            <option value="internal">Virtual Wallet</option>
          )}
        </select>

        <div style={{ marginTop: "16px" }}>To</div>
        <select
          value={withdrawTo}
          onChange={(e) => onToChange(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "8px",
            marginTop: "4px",
            background: "#0b1220",
            color: "#e5e7eb",
            border: "1px solid #1f2937",
          }}
        >
          {wallet === "On-chain" ? (
            <>
              <option value="internal">Virtual Wallet</option>
              <option value="bank">Bank Wallet</option>
              <option value="external_wallet">External Wallet</option>
            </>
          ) : (
            <>
              <option value="bank">Bank Wallet</option>
              <option value="onChain_wallet">Onchain Wallet</option>
              <option value="external_wallet">External Wallet</option>
              <option value="internal_custodiy">Internal PharmaCrowd</option>
            </>
          )}
        </select>

        <div style={{ marginTop: "16px" }}>
          <div style={{ fontSize: "12px", color: "#94a3b8", marginBottom: "4px" }}>Network</div>
          <div style={{
            padding: "8px",
            borderRadius: "8px",
            background: "#0b1220",
            color: "#e5e7eb",
            border: "1px solid #1f2937",
          }}>
            {selectedWithdrawNetwork ? getNetworkName(selectedWithdrawNetwork) : (withdrawTo === "bank" ? "N/A" : (withdrawCoin ? "Loading..." : "Selecting..."))}
          </div>
        </div>

        <div style={{ marginTop: "16px" }}>
          <div style={{ fontSize: "12px", color: "#94a3b8", marginBottom: "4px" }}>Coin</div>
          <div style={{
            padding: "8px",
            borderRadius: "8px",
            background: "#0b1220",
            color: "#e5e7eb",
            border: "1px solid #1f2937",
          }}>
            {withdrawCoin || sidebarWithdraw?.symbol || "Selecting..."}
          </div>
        </div>

        {withdrawCoin && (
          <div style={{ marginTop: "12px", fontSize: "12px", color: "#94a3b8" }}>
            Balance: <FormattedNumber value={internalAmount} maxDecimals={8} /> {withdrawCoin}
          </div>
        )}

        {withdrawAmount && withdrawCoin && (
          <div style={{ marginTop: "12px", fontSize: "12px", color: "#94a3b8" }}>
            Approx Amount after Fee: <FormattedNumber value={approxAmountAfterFee} maxDecimals={5} />
          </div>
        )}

        <div style={{ marginTop: "16px" }}>
          Recipient Address <span style={{ color: "#ff3b6b" }}>*</span>
        </div>
        {withdrawTo === "external_wallet" ? (
          <input
            value={withdrawAddress}
            onChange={(e) => onAddressChange(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "4px",
              borderRadius: "8px",
              border: withdrawError.includes("address") || withdrawError.includes("Address") ? "1px solid #ff3b6b" : "1px solid #1f2937",
              background: "#0b1220",
              color: "#e5e7eb",
            }}
            placeholder="Enter recipient address"
          />
        ) : (
          <div style={{ position: "relative" }}>
            <input
              value={withdrawAddress}
              onChange={(e) => {
                onAddressChange(e.target.value);
                onRecipientSearch(e.target.value);
              }}
              onFocus={(e) => {
                if (e.target.value.length >= 3) {
                  onRecipientSearch(e.target.value);
                }
              }}
              style={{
                width: "100%",
                padding: "8px",
                marginTop: "4px",
                borderRadius: "8px",
                border: withdrawError.includes("address") || withdrawError.includes("Address") ? "1px solid #ff3b6b" : "1px solid #1f2937",
                background: "#0b1220",
                color: "#e5e7eb",
              }}
              placeholder={searchLoad ? "Searching..." : "Search recipient by name"}
            />
            {approverData.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  marginTop: "4px",
                  background: "#0b1220",
                  border: "1px solid #1f2937",
                  borderRadius: "8px",
                  maxHeight: "200px",
                  overflowY: "auto",
                  zIndex: 1000,
                }}
              >
                {approverData.map((option) => {
                  const displayAddress = getDisplayAddress(option);
                  return (
                    <div
                      key={option.id}
                      onClick={() => handleRecipientSelect(option)}
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #1f2937",
                        color: "#e5e7eb",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = "#1f2937";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "transparent";
                      }}
                    >
                      <div style={{ fontWeight: 500 }}>{option.label}</div>
                      {displayAddress && (
                        <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px" }}>
                          {displayAddress}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        <div style={{ marginTop: "16px" }}>
          Amount <span style={{ color: "#ff3b6b" }}>*</span>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <input
            type="number"
            value={withdrawAmount}
            onChange={(e) => onAmountChange(e.target.value)}
            style={{
              flex: 1,
              padding: "8px",
              borderRadius: "8px",
              border: withdrawError.includes("Amount") ? "1px solid #ff3b6b" : "1px solid #1f2937",
              background: "#0b1220",
              color: "#e5e7eb",
            }}
            placeholder="Enter your amount"
          />
          <button
            onClick={onMaxAmount}
            disabled={!withdrawCoin || internalAmount <= 0}
            style={{
              padding: "8px 12px",
              borderRadius: "8px",
              background: "#1f2937",
              border: "1px solid #5ce9ff",
              color: "#5ce9ff",
              cursor: (!withdrawCoin || internalAmount <= 0) ? "not-allowed" : "pointer",
              opacity: (!withdrawCoin || internalAmount <= 0) ? 0.5 : 1,
            }}
          >
            MAX
          </button>
        </div>

        {withdrawAmount && withdrawCoin && (
          <div style={{ marginTop: "12px", fontSize: "12px", color: "#94a3b8" }}>
            {isLoadingFee ? (
              "Calculating fee..."
            ) : withdrawFee ? (
              withdrawFee?.percentage > 0 ? (
                `Fee: ${withdrawFee.percentage}%`
              ) : (
                `Fee: ${withdrawFee.fee || 0} ${withdrawCoin}`
              )
            ) : (
              `Fee: 0.00042 ${withdrawCoin}`
            )}
          </div>
        )}

        {withdrawError && <div style={{ color: "#ff3b6b", marginTop: "8px", fontSize: "12px" }}>{withdrawError}</div>}

        <>
          <div style={{ marginTop: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>OTP Code <span style={{ color: "#ff3b6b" }}>*</span></div>
          </div>
          <input
            value={withdrawOtp}
            onChange={(e) => onOtpChange(e.target.value)}
            disabled={!otpSent}
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "4px",
              borderRadius: "8px",
              border: "1px solid #1f2937",
              background: "#0b1220",
              color: "#e5e7eb",
              opacity: otpSent ? 1 : 0.5,
            }}
            placeholder={otpSent ? "Enter OTP" : "Click 'Send Withdrawal' to receive OTP"}
          />
          {!otpSent && (
            <div style={{ marginTop: "4px", fontSize: "12px", color: "#94a3b8" }}>
              Click "Send Withdrawal" button to automatically receive OTP via email
            </div>
          )}
          {otpSent && (otpSeconds > 0 || otpMinutes > 0) && otpCount < 3 && (
            <div style={{ marginTop: "4px", fontSize: "12px", color: "#5ce9ff" }}>
              Time Remaining: {otpMinutes < 10 ? `0${otpMinutes}` : otpMinutes}:
              {otpSeconds < 10 ? `0${otpSeconds}` : otpSeconds}
            </div>
          )}
          {otpSent && resendOtp && otpCount < 4 && (
            <button
              onClick={onResendOtp}
              disabled={(otpSeconds > 0 || otpMinutes > 0) || isSendingOtp}
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "6px",
                background: "#1f2937",
                border: "1px solid #5ce9ff",
                color: "#5ce9ff",
                cursor: (otpSeconds > 0 || otpMinutes > 0) || isSendingOtp ? "not-allowed" : "pointer",
                fontSize: "12px",
                opacity: (otpSeconds > 0 || otpMinutes > 0) || isSendingOtp ? 0.5 : 1,
                width: "100%",
                fontWeight: 600,
              }}
            >
              {isSendingOtp ? "Sending..." : "Resend OTP"}
            </button>
          )}
        </>

        {isTfaEnabled && (
          <>
            <div style={{ marginTop: "16px" }}>2FA Code</div>
            <input
              value={withdrawTfa}
              onChange={(e) => onTfaChange(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginTop: "4px",
                borderRadius: "8px",
                border: "1px solid #1f2937",
                background: "#0b1220",
                color: "#e5e7eb",
              }}
              placeholder="Enter 2FA Code"
            />
          </>
        )}

        <div style={{ marginTop: "16px", fontSize: "12px", color: "#fbbf24" }}>
          ⚠️ Please double-check the destination address and selected network before confirming the withdrawal.
        </div>

        <button
          disabled={withdrawError !== "" || isSubmitting || (otpSent && !withdrawOtp)}
          onClick={onSubmit}
          style={{
            marginTop: "20px",
            padding: "12px",
            borderRadius: "8px",
            background: withdrawError || (otpSent && !withdrawOtp) ? "#334155" : "#5ce9ff",
            opacity: withdrawError || (otpSent && !withdrawOtp) || isSubmitting ? 0.4 : 1,
            cursor: withdrawError || (otpSent && !withdrawOtp) || isSubmitting ? "not-allowed" : "pointer",
            border: "none",
            width: "100%",
            color: withdrawError || (otpSent && !withdrawOtp) ? "#94a3b8" : "#001018",
            fontWeight: 600,
          }}
        >
          {isSubmitting ? "Processing..." : isSendingOtp ? "Sending OTP..." : "Send Withdrawal"}
        </button>
      </SidebarGlass>
    </>
  );
}

export default WithdrawSidebar;

